import {
  GET_3D_MODEL_URL,
  SET_3D_MODEL_URL,
  CLEAR_3D_MODEL_URL,
  GET_2D_MODEL_URL,
  SET_2D_MODEL_URL,
  CLEAR_2D_MODEL_URL,
  GET_360VIEW_MODEL_URL,
  SET_360VIEW_MODEL_URL,
  CLEAR_360VIEW_MODEL_URL,
  GET_SCAN_INFO,
  CLEAR_SCAN_INFO,
} from "../actions/types";

const initialState = {
  "360View": {
    loading: false,
    modelUrl: null,
    contentType: null,
  },
  "2DModel": {
    loading: false,
    modelUrl: null,
    contentType: null,
  },
  "3DModel": {
    loading: false,
    modelUrl: null,
    contentType: null,
  },
  scanInfo: {
    loading: false,
    data: [],
  },
};

const mergeState = (state, payload) =>
  Object.entries(payload).reduce(
    (nextState, [key, value]) => {
      const currentValue = nextState[key];

      return {
        ...nextState,
        [key]:
          currentValue &&
          typeof currentValue === "object" &&
          !Array.isArray(currentValue) &&
          value &&
          typeof value === "object" &&
          !Array.isArray(value)
            ? { ...currentValue, ...value }
            : value,
      };
    },
    { ...state },
  );

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_360VIEW_MODEL_URL:
      return mergeState(state, payload);
    case SET_360VIEW_MODEL_URL:
      return mergeState(state, payload);
    case CLEAR_360VIEW_MODEL_URL:
      return { ...initialState };
    case GET_3D_MODEL_URL:
      return mergeState(state, payload);
    case SET_3D_MODEL_URL:
      return mergeState(state, payload);
    case CLEAR_3D_MODEL_URL:
      return { ...initialState };
    case GET_2D_MODEL_URL:
      return mergeState(state, payload);
    case SET_2D_MODEL_URL:
      return mergeState(state, payload);
    case CLEAR_2D_MODEL_URL:
      return { ...initialState };
    case GET_SCAN_INFO:
      return mergeState(state, payload);
    case CLEAR_SCAN_INFO:
      return { ...state, scanInfo: { loading: false, data: [] } };
    default:
      return state;
  }
}
